<template>
  <v-list
      v-if="buyoutItem"
      class="py-0"
      :dense="$vuetify.breakpoint.mobile"
  >
    <v-subheader>
      <b>{{getPickupPointSectionTitle()}}</b>
    </v-subheader>

    <v-skeleton-loader
        v-if="pickupPointIsDefaultLoading"
        type="list-item-avatar-two-line"
    ></v-skeleton-loader>

    <v-list-item
        v-else-if="buyoutItem.pickupPointAdmin"
        two-line
    >
      <v-list-item-avatar>
        <v-icon class="primary white--text">mdi-store</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="primary--text">
          {{getPickupPointTitle(buyoutItem.pickupPointAdmin)}}
        </v-list-item-title>
        <v-list-item-subtitle>Адрес: {{buyoutItem.pickupPointAdmin.address}}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item
        v-if="!pickupPointIsDefaultLoading && !(buyoutItem.pickupPointAdmin && !buyoutItem.pickupPointCustomer)"
        three-line
        @click="setupPickupPoint"
    >
      <v-list-item-avatar>
        <v-icon
            v-if="pickupPointIsDefault"
            class="accent white--text"
        >
          mdi-check-circle-outline
        </v-icon>
        <v-icon
            v-else
            class="white--text"
            :class="{'primary': buyoutItem.pickupPointCustomer && !buyoutItem.pickupPointAdmin, 'red': buyoutItem.pickupPointAdmin || !buyoutItem.pickupPointCustomer}">
          >
          mdi-store
        </v-icon>
      </v-list-item-avatar>

      <v-list-item-content v-if="buyoutItem.pickupPointCustomer">
        <v-list-item-title
            :class="{'red--text text-decoration-line-through': buyoutItem.pickupPointAdmin, 'primary--text': !buyoutItem.pickupPointAdmin && !pickupPointIsDefault, 'accent--text': !buyoutItem.pickupPointAdmin && pickupPointIsDefault}"
        >
          {{getPickupPointTitle(buyoutItem.pickupPointCustomer)}}
        </v-list-item-title>
        <v-list-item-subtitle v-if="buyoutItem.pickupPointAdmin">
          Точка выдачи была изменена организатором
        </v-list-item-subtitle>
        <v-list-item-subtitle
            v-if="pickupPointIsDefault"
            class="accent--text"
        >
          Точка выбрана по умолчанию
        </v-list-item-subtitle>
        <v-list-item-subtitle
            v-if="!buyoutItem.pickupPointAdmin"
            class="expanded"
        >
          <span
              v-if="!hasUnconfirmed"
              class="warning--text information"
          >
            Точку выдачи после оплаты может изменить только организатор<br/>
          </span>
          Адрес: {{buyoutItem.pickupPointCustomer.address}}
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-content v-else>
        <v-list-item-title class="red--text">Не задано</v-list-item-title>
        <v-list-item-subtitle v-if="hasUnconfirmed">Нажмите, чтобы выбрать</v-list-item-subtitle>
        <v-list-item-subtitle
            v-else
            class="warning--text expanded information"
        >
          Точку выдачи после оплаты может задать только организатор
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import {getSourceId} from '@/composables/context'
import {appStates, status} from '@/constants'
import {getPickupPointTitle} from '@/services/utils'

export default {
  name: 'BuyoutItemInfoPickupPoint',
  data () {
    return {
      deliveryStatuses: status.delivery,
      hasUnconfirmed: !!(this.buyoutItem?.invoices && this.buyoutItem.invoices.find(elm => elm.status !== status.payment.payed.id)),
      pickupPointIsDefault: false,
      pickupPointIsDefaultLoading: true,
    }
  },
  methods: {
    getPickupPointTitle: getPickupPointTitle,
    getPickupPointSectionTitle: function () {
      switch (this.buyoutItem.deliveryStatus) {
        case this.deliveryStatuses.admin.id:
          return `Точка выдачи${this.buyoutItem.pickupPointAdmin ? ', выбранная организатором' : ''}`
        case this.deliveryStatuses.customer.id:
          return 'Забрано с точки выдачи'
        default:
          return 'Товар на точке выдачи'
      }
    },
    setupPickupPoint: function () {
      if (this.buyoutItem.pickupPointAdmin || this.buyoutItem.deliveryStatus !== this.deliveryStatuses.admin.id
          || !this.hasUnconfirmed) return //TODO: move payment status to buyoutItem
      this.$router.push({
        name: appStates.buyoutPickupPointSet.name, params: {sourceId: getSourceId(), buyoutId: this.buyoutItem.buyoutId}
      })
    }
  },
  props: {
    buyoutItem: {
      type: Object
    },
    loading: {
      required: true,
      type: Boolean
    }
  },
  watch: {
    loading: {
      handler (value) {
        if (!value) {
          this.$client.get(this.$API.PICKUP_POINTS.DEFAULT.GET, {params: {sourceId: getSourceId()}})
              .then(rs => {
                this.pickupPointIsDefault = rs.id ? this.buyoutItem.pickupPointIdCustomer === rs.id : false
                this.pickupPointIsDefaultLoading = false
              })
        }
      },
      immediate: true
    },
    buyoutItem (val) {
      if (!val) return

      this.hasUnconfirmed = !!(val.invoices && val.invoices.find(elm => elm.status !== status.payment.payed.id))
    }
  }
}
</script>

<style scoped>
.information {
  font-size: 12px;
}
</style>
